import React, {useState} from 'react';
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {CallBackProps, STATUS, Step, EVENTS, ACTIONS} from "react-joyride";
import {Journey} from "@dropDesk/presentation/components/journeys/joyride";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";

export const JourneyListTicketsNews = (
    {
        defaultRun,
    }: {
        defaultRun?: boolean
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const [stepIndex, setStepIndex] = useState(0);
    const [run, setRun] = useState(defaultRun ?? false);

    const handleJoyrideCallback = (data: CallBackProps) => {
        const {action, index, status, type} = data;

        if (type === EVENTS.STEP_AFTER) {
            setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
        } else if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
            setRun(false);
            setStepIndex(0);
            localStorage.setItem(`${appController.user!.id}${ConstantsKeys.tourListTicketsNews}`, JSON.stringify({
                read: status === STATUS.FINISHED,
                skip: status === STATUS.SKIPPED
            }));
        }
    };

    const steps: Array<Step> = [
        {
            placement: 'center',
            target: 'body',
            title: <h4 style={{color: colors.text}}>Novidades na lista de atendimentos</h4>,
            content: <span style={{fontSize: 15}}>Deixamos a busca de atendimentos mais rápida e prática, siga para o próximo passo para conhecer.</span>,
        },
        {
            floaterProps: {
                disableAnimation: true,
            },
            spotlightPadding: 20,
            target: '.input-search-journey',
            title: <h4 style={{color: colors.text}}>Busca mais completa</h4>,
            content: <span style={{fontSize: 15}}>A pesquisa principal agora encontra atendimentos por <b>protocolo, telefone ou nome do contato</b>. Basta digitar e pesquisar.</span>
        },
        {
            floaterProps: {
                disableAnimation: true,
            },
            spotlightPadding: 20,
            target: '.input-filter-period-journey',
            title: <h4 style={{color: colors.text}}>Filtro de período sempre à mão</h4>,
            content: <span style={{fontSize: 15}}>O período saiu do popup de filtros e agora fica direto na barra de pesquisa. Use os atalhos (<b>Semana atual, Mês atual, Mês passado, Últimos 3, 6 ou 12 meses</b>) ou escolha um intervalo personalizado de até 1 ano. Por padrão, são exibidos os atendimentos dos <b>últimos 3 meses</b>.</span>
        },
    ];

    return (
        <Journey
            handleJoyrideCallback={handleJoyrideCallback}
            continuous={true}
            run={run}
            stepIndex={stepIndex}
            steps={steps}
        />
    );

};
